import {WidgetController} from "../widgetController";

const updateDelayInMillisecond = 1200;

export class RankingWidgetController extends WidgetController {
  constructor(componentId, legends, updateCallback) {
    super(componentId, legends);
    this.historySize = 1;
    this.updateCallback = updateCallback;
    this.legends = legends;
  }

  loadHistoricData(historicData) {
    let convertedData = {};
    for (let datasetId in historicData) {
      convertedData[datasetId] = historicData[datasetId][0];
    }
    this.latestData = this.processData(convertedData);
    this.sortData();
    this.updateCallback(this.latestData);
  }

  update() {
    this.latestData = this.processData();
    this.sortData();
    this.updateCallback(this.latestData);
  }

  sortData() {
    // adding legend id to data because data will be sorted
    this.latestData.forEach((d, i) => d.id = this.legends[i].id);
    this.latestData = this.latestData.sort((a,b) => b.y - a.y);
  }

  getHistorySize() {
    return this.historySize;
  }

  getLegends() {
    return this.legends;
  }

  onLegendUpdated() {
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.updateCallback(this.latestData);
    }, 300);
  }

  destroy() {
    clearTimeout(this.updateTimer);
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/ranking/controller.js